/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NewImport } from './routes/new'
import { Route as LoginImport } from './routes/login'
import { Route as IndexImport } from './routes/index'
import { Route as ConversationIdImport } from './routes/conversation.$id'

// Create Virtual Routes

const UploadFilesLazyImport = createFileRoute('/upload-files')()
const IndexedFilesLazyImport = createFileRoute('/indexed-files')()
const DocumentsLazyImport = createFileRoute('/documents')()
const CreatorLazyImport = createFileRoute('/creator')()

// Create/Update Routes

const UploadFilesLazyRoute = UploadFilesLazyImport.update({
  id: '/upload-files',
  path: '/upload-files',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/upload-files.lazy').then((d) => d.Route))

const IndexedFilesLazyRoute = IndexedFilesLazyImport.update({
  id: '/indexed-files',
  path: '/indexed-files',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/indexed-files.lazy').then((d) => d.Route))

const DocumentsLazyRoute = DocumentsLazyImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/documents.lazy').then((d) => d.Route))

const CreatorLazyRoute = CreatorLazyImport.update({
  id: '/creator',
  path: '/creator',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/creator.lazy').then((d) => d.Route))

const NewRoute = NewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ConversationIdRoute = ConversationIdImport.update({
  id: '/conversation/$id',
  path: '/conversation/$id',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewImport
      parentRoute: typeof rootRoute
    }
    '/creator': {
      id: '/creator'
      path: '/creator'
      fullPath: '/creator'
      preLoaderRoute: typeof CreatorLazyImport
      parentRoute: typeof rootRoute
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsLazyImport
      parentRoute: typeof rootRoute
    }
    '/indexed-files': {
      id: '/indexed-files'
      path: '/indexed-files'
      fullPath: '/indexed-files'
      preLoaderRoute: typeof IndexedFilesLazyImport
      parentRoute: typeof rootRoute
    }
    '/upload-files': {
      id: '/upload-files'
      path: '/upload-files'
      fullPath: '/upload-files'
      preLoaderRoute: typeof UploadFilesLazyImport
      parentRoute: typeof rootRoute
    }
    '/conversation/$id': {
      id: '/conversation/$id'
      path: '/conversation/$id'
      fullPath: '/conversation/$id'
      preLoaderRoute: typeof ConversationIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/creator': typeof CreatorLazyRoute
  '/documents': typeof DocumentsLazyRoute
  '/indexed-files': typeof IndexedFilesLazyRoute
  '/upload-files': typeof UploadFilesLazyRoute
  '/conversation/$id': typeof ConversationIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/creator': typeof CreatorLazyRoute
  '/documents': typeof DocumentsLazyRoute
  '/indexed-files': typeof IndexedFilesLazyRoute
  '/upload-files': typeof UploadFilesLazyRoute
  '/conversation/$id': typeof ConversationIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/creator': typeof CreatorLazyRoute
  '/documents': typeof DocumentsLazyRoute
  '/indexed-files': typeof IndexedFilesLazyRoute
  '/upload-files': typeof UploadFilesLazyRoute
  '/conversation/$id': typeof ConversationIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/new'
    | '/creator'
    | '/documents'
    | '/indexed-files'
    | '/upload-files'
    | '/conversation/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/new'
    | '/creator'
    | '/documents'
    | '/indexed-files'
    | '/upload-files'
    | '/conversation/$id'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/new'
    | '/creator'
    | '/documents'
    | '/indexed-files'
    | '/upload-files'
    | '/conversation/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  NewRoute: typeof NewRoute
  CreatorLazyRoute: typeof CreatorLazyRoute
  DocumentsLazyRoute: typeof DocumentsLazyRoute
  IndexedFilesLazyRoute: typeof IndexedFilesLazyRoute
  UploadFilesLazyRoute: typeof UploadFilesLazyRoute
  ConversationIdRoute: typeof ConversationIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  NewRoute: NewRoute,
  CreatorLazyRoute: CreatorLazyRoute,
  DocumentsLazyRoute: DocumentsLazyRoute,
  IndexedFilesLazyRoute: IndexedFilesLazyRoute,
  UploadFilesLazyRoute: UploadFilesLazyRoute,
  ConversationIdRoute: ConversationIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/login",
        "/new",
        "/creator",
        "/documents",
        "/indexed-files",
        "/upload-files",
        "/conversation/$id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/new": {
      "filePath": "new.tsx"
    },
    "/creator": {
      "filePath": "creator.lazy.tsx"
    },
    "/documents": {
      "filePath": "documents.lazy.tsx"
    },
    "/indexed-files": {
      "filePath": "indexed-files.lazy.tsx"
    },
    "/upload-files": {
      "filePath": "upload-files.lazy.tsx"
    },
    "/conversation/$id": {
      "filePath": "conversation.$id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
